// START A/B TEST PLGRWEB-1647-SearchPage-Previous Searches

import { AbTest } from 'abTests/lib/AbTest';
import { UserStorage } from 'helpers/userStorage';
import JsonParse from 'helpers/jsonParse';
import HttpService from 'services/HttpService';
import landscapeCarousel from '../../components/landscapeCarousel';

const MAX_CONTENT_IDS_ALLOW = 20;

export default class SearchPagePreviousSearch extends AbTest {
    constructor() {
        super(CBS?.AbTestsConfigs?.modules?.SearchPagePreviousSearch);
        this.implement();
        this.storageKey = 'prevSearch';
        this.contentIDsLocalStorage = new UserStorage();
        this._http = new HttpService();
        this.initContentIDsLocalStorageState();
    }

    /**
     * retrieve content Ids list from localStorage Using Helper
     * if localStorage does not have any, set default to empty array
     */
    initContentIDsLocalStorageState() {
        // read from the storage for the state of contentIds
        this.contentIDsStorage = this.contentIDsLocalStorage.get(this.storageKey) ?? [];

        //consider moving to liveHelper.js since is generic
        if (typeof this.contentIDsStorage === 'string') {
            this.contentIDsStorage = JsonParse(this.contentIDsStorage);
        }
    }

    /**
     * add this tiles movie contentId or showId to the contentIds array
     * set this contentIds list array in localstorage
     * send this contentIds list array to PHP to set Cookie because
     - search page personalized carousel is done in php call
     - if done in js, would cause flicker
     - would have to do much more code if build this recent search carousel in js
     - save an api call if send this contentIds list array to PHP to set Cookie
     * @param tile
     * @param event
     * @param hasContentHighlight
     */
    storeThisTile(tile, event, hasContentHighlight = false) {
        return new Promise((resolve) => {
            event.preventDefault();
            const anchorLink = hasContentHighlight ? tile : event.currentTarget;
            const aaLink = anchorLink.getAttribute('aa-link').split('|');

            const contentID = aaLink[9] ?? null;

            if (contentID) {
                //if this showId/MovieContentId is already in the list,
                //delete the contentId from the array
                //then insert this showId or MovieContentId in the beginning of array
                //so this tile would become most recent
                this.deleteDuplicateInContentList(contentID);

                //add showId/MovieContentId into this content list array
                this.contentIDsStorage.unshift(contentID);

                //add showId/MovieContentId into this content list array
                if (this.contentIDsStorage.length > MAX_CONTENT_IDS_ALLOW) {
                    // Function to ensure content Ids array length does not exceed 20
                    this.contentIDsStorage.pop();
                }

                //store in local storage
                this.contentIDsLocalStorage.store(this.storageKey, this.contentIDsStorage);

                //sends content ids array asynchronously
                this._http
                    .doGet(`/carousels/searchPage/previousSearch/${this.contentIDsStorage.length}/`)
                    .then((response) => {
                        if (response.success) {
                            if (!hasContentHighlight) {
                                window.location = anchorLink.getAttribute('href') ?? '/';
                            }
                            resolve('');
                        }
                    });
            } else {
                if (!hasContentHighlight) {
                    window.location = anchorLink.getAttribute('href') ?? '/';
                }
            }
        });
    }

    /*    
        @param contentId
        delete if duplicated, Duplicates in ContentList
     */
    deleteDuplicateInContentList(contentID) {
        const elementIndex = this.contentIDsStorage.findIndex((everyContentId) => {
            return contentID === everyContentId;
        });
        if (elementIndex !== -1) {
            this.contentIDsStorage.splice(elementIndex, 1);
        }
    }

    /*
        @param movieAnchor
        if this tile is movie, since AA-Link does not contain movieContentID
        extract movieContentId from href
     */
    extractMovieContentID(movieAnchor) {
        const movieHref = movieAnchor.getAttribute('href');
        // Split the URL by '/'
        const parts = movieHref.split('/');
        // Get the last part (which is the last element in the array)
        return parts[parts.length - 2]; // Using parts.length - 2 to account for the trailing slash
    }

    /**
     * builds recent search carousel
     * contentIds: ${contentIds.join(",")}
     */
    loadPreviousSearchCarousel() {
        const contentIds = JsonParse(this.contentIDsLocalStorage.get(this.storageKey));
        const recentSearchCarousel = $('#recent-search')[0];

        if (contentIds && contentIds.length > 1 && recentSearchCarousel) {
            (async () => {
                const contentHighlightCarousel = await import(
                    'components/highlight/carousel/ContentHighlightCarousel'
                );
                const myInstance = new contentHighlightCarousel.default({
                    orientation: 'portrait',
                    parentContainer: recentSearchCarousel,
                    options: {
                        contentHighlight: true,
                        endPoint:
                            CBS.Registry.region.prefix +
                            `/carousels/searchContentIDs/${contentIds.join(',')}/?activeVariant=${CBS?.AbTestsConfigs?.modules?.SearchPagePreviousSearch?.activeVariant}`,
                    },
                });
            })();
        }
    }
}

/**
 * singleton pattern
 * The pattern ensures that there is only one instance of the class and provides a global point of access to that instance.
 */
export const initializePreviousSearchInstance = () => {
    if (CBS?.AbTestsConfigs?.modules?.SearchPagePreviousSearch?.inVariants) {
        return !window?.abTests?.SearchPagePreviousSearch
            ? new SearchPagePreviousSearch()
            : window?.abTests?.SearchPagePreviousSearch;
    }

    return false;
};

/**
 * if recent search instance exists,
 * build rent search carousel in js
 * contentIds is appended the url
 */
export const loadRecentCarouselWrapper = () => {
    const prevSearchInstance = initializePreviousSearchInstance();
    if (prevSearchInstance) {
        prevSearchInstance.loadPreviousSearchCarousel();
    }
};

export const trackRecentSearchCarousel = (tileTrackObj) => {
    if (
        tileTrackObj.rowHeaderTitle &&
        (tileTrackObj.rowHeaderTitle === 'Previous Searches' ||
            tileTrackObj.rowHeaderTitle === 'My Search History')
    ) {
        return {
            ...tileTrackObj,
            searchTerm:
                tileTrackObj.movieTitle && tileTrackObj.movieTitle !== ''
                    ? tileTrackObj.movieTitle
                    : tileTrackObj.showSeriesTitle,
            carouselModel: 'showMovieHybrid',
            searchResultSelect: '1',
            searchEventComplete: '1',
        };
    }

    return tileTrackObj;
};
// END A/B TEST PLGRWEB-1647-SearchPage-Previous Searches
